/** Reading the backend's failures. Separate from the view so both are unit-testable
 *  and so the component file exports only a component (fast refresh). */

/** The backend 400s anyone above rep level with the reps they could ask for.
 *
 *  Read defensively: a shape change must degrade to a plain error, never to a picker
 *  built from undefined. */
export function extractRepChoices(err: unknown): { message: string; reps: string[] } | null {
  const res = (err as { response?: { status?: number; data?: { detail?: unknown } } })?.response;
  if (res?.status !== 400) return null;
  const body = res.data?.detail as { message?: unknown; reps?: unknown } | undefined;
  if (!body || !Array.isArray(body.reps) || body.reps.length === 0) return null;
  return {
    message: typeof body.message === 'string' ? body.message : 'Pick a rep to plan for.',
    reps: body.reps.filter((r): r is string => typeof r === 'string'),
  };
}

/** Axios buries the useful text; its own message is only ever "Request failed with
 *  status code 400", which tells a rep nothing they can act on. */
export function describeError(err: unknown, fallback: string): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object') {
    const message = (detail as { message?: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  return err instanceof Error && err.message ? err.message : fallback;
}
